import React from 'react';
import { rangeFromTareas, diffDays, xDias, anchoDias } from './constants';

/**
 * Barra agregada que cubre el rango temporal de un grupo (proyecto o categoría)
 * en la fila de su header. Estilo ClickUp: relleno semitransparente del color
 * del grupo, fina y centrada verticalmente. Se ubica con --dw (ver xDias).
 *
 * Devuelve null si ninguna tarea del grupo tiene fechas (no se pinta nada).
 */
const GroupRangeBar = ({ tareas, firstDay, color }) => {
  const range = rangeFromTareas(tareas);
  if (!range) return null;

  const offset = diffDays(range.min, firstDay);
  const duration = diffDays(range.max, range.min) + 1;

  return (
    <div
      className="absolute top-1/2 -translate-y-1/2 h-2 rounded-sm pointer-events-none"
      style={{
        left: xDias(offset),
        width: anchoDias(duration, 2, 4),
        backgroundColor: `${color}4d`, // ~30% opacity
      }}
    />
  );
};

export default GroupRangeBar;
